import useI18n from "../../i18n/useI18n";

// HE ⇄ EN switch. Shows both codes with the active one highlighted.
const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang, t } = useI18n();

  return (
    <div
      className={`lang-toggle ${className}`.trim()}
      role="group"
      aria-label={t("lang.label")}
    >
      <button
        type="button"
        className={`lang-toggle__opt${lang === "he" ? " is-active" : ""}`}
        aria-pressed={lang === "he"}
        onClick={() => setLang("he")}
      >
        HE
      </button>
      <span className="lang-toggle__sep" aria-hidden="true">/</span>
      <button
        type="button"
        className={`lang-toggle__opt${lang === "en" ? " is-active" : ""}`}
        aria-pressed={lang === "en"}
        onClick={() => setLang("en")}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
